/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Fileviewer_Footer_Help_SmallInputs */



/**
* | output |
* | --- |
* | "Arrow keys • +/- zoom • Drag to pan" |
*
* @param {Spaces_Fileviewer_Footer_Help_SmallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_fileviewer_footer_help_small = /** @type {((inputs?: Spaces_Fileviewer_Footer_Help_SmallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Fileviewer_Footer_Help_SmallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pfeiltasten • +/- Zoom • Ziehen zum Verschieben")
	return /** @type {LocalizedString} */ ("Arrow keys • +/- zoom • Drag to pan")
});